export const LOCATION_MSK = 'MSK';
export const LOCATION_SPB = 'SPB';
export const LOCATION_NIZ = 'NIZ';
export const LOCATION_KZN = 'KZN';

export const LOCATION_TUL = 'TUL';
export const LOCATION_YAR = 'YAR';
export const LOCATION_VLA = 'VLA';
export const LOCATION_VOR = 'VOR';
export const LOCATION_RYA = 'RYA';
export const LOCATION_KLU = 'KLU';
export const LOCATION_TVE = 'TVE';

export const SPB_CODES = [
    'RU-LEN',
    'RU-SPE',
];
export const MSK_CODES = [
    'RU-MOS',
    'RU-MOW',
];
export const NIZ_CODES = [
    'RU-NIZ',
    'RU-NIO',
];

export const KZN_CODES = [
    'RU-TA',
    'RU-TAO',
];

export const TUL_CODES = ['RU-TUL'];
export const YAR_CODES = ['RU-YAR'];
export const VLA_CODES = ['RU-VLA'];
export const RYA_CODES = ['RU-RYA'];
export const KLU_CODES = ['RU-KLU'];
export const TVE_CODES = ['RU-TVE'];
export const VOR_CODES = ['RU-VOR'];

export const citiesLocales = [
    {
        id: LOCATION_MSK,
        mobileTitle: 'Мск',
        desktopTitle: 'Москва',
        value: 'Москва и МО',
    },
    {
        id: LOCATION_SPB,
        mobileTitle: 'CПб',
        desktopTitle: 'C.Петербург',
        value: 'C.Петербург и ЛО',
    },
    {
        id: LOCATION_VLA,
        mobileTitle: 'Владимир',
        desktopTitle: 'Владимир',
        value: 'Владимир и область',
    },
    {
        id: LOCATION_VOR,
        mobileTitle: 'Воронеж',
        desktopTitle: 'Воронеж',
        value: 'Воронеж и область',
    },
    {
        id: LOCATION_KZN,
        mobileTitle: 'Казань',
        desktopTitle: 'Казань',
        value: 'Казань и область',
    },
    {
        id: LOCATION_KLU,
        mobileTitle: 'Калуга',
        desktopTitle: 'Калуга',
        value: 'Калуга и область',
    },
    {
        id: LOCATION_NIZ,
        mobileTitle: 'НН',
        desktopTitle: 'Н.Новгород',
        value: 'Н.Новгород и область',
    },
    {
        id: LOCATION_RYA,
        mobileTitle: 'Рязань',
        desktopTitle: 'Рязань',
        value: 'Рязань и область',
    },
    {
        id: LOCATION_TVE,
        mobileTitle: 'Тверь',
        desktopTitle: 'Тверь',
        value: 'Тверь и область',
    },
    {
        id: LOCATION_TUL,
        mobileTitle: 'Тула',
        desktopTitle: 'Тула',
        value: 'Тула и область',
    },
    {
        id: LOCATION_YAR,
        mobileTitle: 'Ярославль',
        desktopTitle: 'Ярославль',
        value: 'Ярославль и область',
    },
];

export const citiesLocalesEng = [
    {
        id: LOCATION_MSK,
        mobileTitle: 'Msk',
        desktopTitle: 'Moscow',
        value: 'Moscow',
    },
    {
        id: LOCATION_SPB,
        mobileTitle: 'Spb',
        desktopTitle: 'St. Petersburg',
        value: 'St. Petersburg',
    },
    {
        id: LOCATION_VLA,
        mobileTitle: 'Vladimir',
        desktopTitle: 'Vladimir',
        value: 'Vladimir',
    },
    {
        id: LOCATION_VOR, // добавлен, так как есть в русском массиве
        mobileTitle: 'Voronezh',
        desktopTitle: 'Voronezh',
        value: 'Voronezh',
    },
    {
        id: LOCATION_KZN,
        mobileTitle: 'Kazan',
        desktopTitle: 'Kazan',
        value: 'Kazan',
    },
    {
        id: LOCATION_KLU,
        mobileTitle: 'Kaluga',
        desktopTitle: 'Kaluga',
        value: 'Kaluga',
    },
    {
        id: LOCATION_NIZ,
        mobileTitle: 'NN',
        desktopTitle: 'Nizhny Novgorod',
        value: 'Nizhny Novgorod',
    },
    {
        id: LOCATION_RYA,
        mobileTitle: 'Ryazan',
        desktopTitle: 'Ryazan',
        value: 'Ryazan',
    },
    {
        id: LOCATION_TVE,
        mobileTitle: 'Tver',
        desktopTitle: 'Tver',
        value: 'Tver',
    },
    {
        id: LOCATION_TUL,
        mobileTitle: 'Tula',
        desktopTitle: 'Tula',
        value: 'Tula',
    },
    {
        id: LOCATION_YAR,
        mobileTitle: 'Yaroslavl',
        desktopTitle: 'Yaroslavl',
        value: 'Yaroslavl',
    },
];

// Texts used in tags / dialogs (not the same as dropdown titles).
export const citiesMeta = {
    [LOCATION_MSK]: { title: 'Москва', longTitle: 'Москва', engTitle: 'Moscow' },
    [LOCATION_SPB]: { title: 'С-Петербург', longTitle: 'Cанкт-Петербург', engTitle: 'St. Petersburg' },
    [LOCATION_NIZ]: { title: 'Н.Новгород', longTitle: 'Нижний Новгород', engTitle: 'Nizhny Novgorod' },
    [LOCATION_KZN]: { title: 'Казань', longTitle: 'Казань', engTitle: 'Kazan' },
    [LOCATION_TUL]: { title: 'Тула', longTitle: 'Тула', engTitle: 'Tula' },
    [LOCATION_YAR]: { title: 'Ярославль', longTitle: 'Ярославль', engTitle: 'Yaroslavl' },
    [LOCATION_VLA]: { title: 'Владимир', longTitle: 'Владимир', engTitle: 'Vladimir' },
    [LOCATION_VOR]: { title: 'Воронеж', longTitle: 'Воронеж', engTitle: 'Voronezh' },
    [LOCATION_RYA]: { title: 'Рязань', longTitle: 'Рязань', engTitle: 'Ryazan' },
    [LOCATION_KLU]: { title: 'Калуга', longTitle: 'Калуга', engTitle: 'Kaluga' },
    [LOCATION_TVE]: { title: 'Тверь', longTitle: 'Тверь', engTitle: 'Tver' },
};

export const getCityMetaByLocationKey = (locationKey) => citiesMeta[locationKey] || citiesMeta[LOCATION_MSK];
